import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M2 21.9999V8.62515C2.90587 9.30584 4.02447 9.71972 5.23964 9.7484L6.98987 21.9999H2Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M6.92487 7.40291C6.45495 7.62549 5.92952 7.75 5.375 7.75C5.23145 7.75 5.08984 7.74166 4.95064 7.72543C3.6022 7.5682 2.47969 6.67094 2 5.45053V2H22V5.45053C21.5203 6.67094 20.3978 7.5682 19.0494 7.72543C18.9102 7.74166 18.7686 7.75 18.625 7.75C18.0705 7.75 17.545 7.62549 17.0751 7.40291C16.9488 7.34307 16.8265 7.27614 16.7087 7.20263C16.0976 6.82133 15.6083 6.2631 15.3125 5.59962C15.0167 6.2631 14.5274 6.82133 13.9163 7.20263C13.3604 7.54955 12.7036 7.75 12 7.75C11.2964 7.75 10.6396 7.54955 10.0837 7.20263C9.47259 6.82133 8.98331 6.2631 8.6875 5.59962C8.3917 6.2631 7.90241 6.82133 7.29134 7.20263C7.17354 7.27614 7.05121 7.34307 6.92487 7.40291Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7.21614 9.44172C7.74738 9.25773 8.24229 8.9964 8.6875 8.67138C9.61594 9.34917 10.7605 9.75 12 9.75C13.2395 9.75 14.3841 9.34917 15.3125 8.67138C15.7577 8.99639 16.2526 9.25773 16.7839 9.44172L14.9898 21.9999H9.01018L7.21614 9.44172Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M17.0101 21.9999L18.7604 9.7484C19.9755 9.71972 21.0941 9.30584 22 8.62515V21.9999H17.0101Z"}}]};

const CurtainFilled = Vue.extend<IconProps>({
  name: 'CurtainFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'curtain-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default CurtainFilled;
